import React, { useState } from "react";
import { cn } from "helper/Utils";

const PaymentOptions = ({ options, selectedPayment, setSelectedPayment }) => {
  const [selectedCategory, setSelectedCategory] = useState("all");
  // const handleFilterChange = (category) => {
  //   setSelectedCategory(category);
  // };

  const filteredPaymentOptions = options.filter((fi) => fi.category.includes(selectedCategory));
  return (
    <>
      <style jsx="true">
        {`
          .paymentCardBoxShadow {
            box-shadow: inset 0 -1px rgba(0, 12, 36, 0.1);
          }
        `}
      </style>

      {/* <div className="flex gap-2 mb-3 md:mt-[15px] overflow-x-auto hide-scrollbar">
        {PAYMENT_OPTION_FILTERS.map((category) => (
          <button
            key={category.value}
            className={`flex xl:flex-row flex-col justify-center items-center xl:text-[14px] text-[10px] xl:gap-2 gap-1 xl:uppercase capitalize px-3 py-2 rounded leading-none text-nowrap xl:min-w-auto min-w-[80px] ${
              selectedCategory === category.value ? "bg-primary text-white" : "bg-white bg-opacity-10 text-gray"
            }`}
            onClick={() => handleFilterChange(category.value)}
          >
            <span className="xl:text-[18px] text-[26px] leading-none">{category.icon}</span>
            {category.label}
          </button>
        ))}
      </div> */}
      {filteredPaymentOptions && filteredPaymentOptions.length ? (
        <div className="w-full pt-1 pb-2 grid gap-2 text-center grid-rows-auto grid-cols-[repeat(auto-fill,minmax(100px,1fr))]">
          {filteredPaymentOptions.map((item) => (
            <div
              key={item.id}
              className={cn(
                "w-full bg-white text-white cursor-pointer lg:h-[50px] rounded-md hover:ring-2 ring-primary hover:bg-white/30]",
                selectedPayment && selectedPayment.id === item.id ? "ring-2 ring-primary bg-white" : ""
              )}
              onClick={() => setSelectedPayment(item)}
            >
              <div className="w-full h-full flex flex-col px-2.5 justify-center items-center relative">
                <div className="border-b-2 border-[rgb(0,12,36,1)] sm:border-none w-full flex justify-center items-center">
                  <img src={`${item.image}`} alt={item.title} className="w-full max-w-[80%] sm:max-w-none h-[56px] lg:h-auto object-contain" />
                </div>
                <p className="p-2 lg:hidden min-h-[42px] text-black text-[12px]">{item.title}</p>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="py-10 text-center text-white/70 text-[12px]">There are no payment options for selected type</div>
      )}
    </>
  );
};

export default PaymentOptions;
